if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

import $ from "jquery";
import slick from 'slick-carousel';
import 'slick-carousel/slick/slick.scss';

import * as Altcha from 'altcha';

import validate from 'jquery-validation';
import { layer } from './part/layer.js';

import Plyr from 'plyr';

import {layerVideo} from './part/video';

// import nideScroll from 'jquery.nicescroll';

// import jQueryBridget from 'jquery-bridget';
// import Masonry from "masonry-layout";
// jQueryBridget('masonry', Masonry, $);

import SimpleShare from './part/simple-share';



import Pjax from 'pjax';
// import Modernizr from "modernizr";

// import { gsap } from 'gsap';

import AOS from 'aos';
import 'aos/src/sass/aos.scss';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

import 'select2/dist/css/select2.min.css';
import select2 from 'select2';

import './iconfont/iconfont.js';



import Language from './language';
const lang = new Language();


$.validator.addMethod("isMobile", function(value, element) {  
    var length = value.length;  
    var mobile = /^(1[0-9][0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/;  
    return this.optional(element) || (length == 11 && mobile.test(value));  
}, lang.phoneErr); 
$.validator.addMethod("valueNotEquals", function(value, element, arg){
	return arg !== value;
}, lang.selectAnItem);
$.extend($.validator.messages, {
	required: lang.required,
	email: lang.emailErr,
	digits: lang.digits
});


function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

function scrollTo(id) {
    var d = $(id).offset().top - $('.header').outerHeight();
    $('html,body').stop().animate({
            scrollTop : d
    }, 'slow');
}


(function index() {

    var $body = $('body');

    $('.js-open-hs').on('click', function(){
        $body.addClass('search-open');
    });
    $('.js-close-hs').on('click', function(){
        $body.removeClass('search-open');
    });

    $('.js-btn-menu').on('click', function(){
        $('body').toggleClass('menu-open');
    });

    $('.js-subm-link').on('mouseenter', function(){
        const id = $(this).data('id');
        $(this).addClass('current').siblings().removeClass('current');
        $(this).parents('.submenu-wrap').addClass('active');
        $('.submenur-item').removeClass('active');
        $('.submenur-item[data-id='+id+']').addClass('active');

    });


    // Mobile Menu
    $('.hm-link span').on('click', function(e){
        const li = $(this).parents('li');
        if (li.hasClass('has-sub') && $(window).innerWidth() < 1101) {
            const subMenu = li.find('.sub-menu');
            e.preventDefault();
            
            if (li.hasClass('active')) {
                li.removeClass('active');
                subMenu.slideUp(300);
            } else {
                $('.hm-item').removeClass('active');
                $('.sub-menu').slideUp(300);
                li.addClass('active');
                subMenu.stop().slideDown(300);
            }
        }
    });



    if ($('.js-response-img').length) {
        $(window).on('resize', function(){
            $('.js-response-img').each(function(index, item){
                var imgPC = $(item).attr('data-pc');
                var imgM = $(item).attr('data-m');
                // console.log(imgPC, imgM, window.innerWidth > 768 ? imgPC : imgM);
                var img = window.innerWidth > 750 ? imgPC : imgM
                $(item).attr('src', img);
            });
        }).trigger('resize');
    }
    if ($('.js-response-bg').length) {
        $(window).on('resize', function(){
            $('.js-response-bg').each(function(index, item){
                var imgPC = $(item).attr('data-pc');
                var imgM = $(item).attr('data-m');
                // console.log(imgPC, imgM, window.innerWidth > 768 ? imgPC : imgM);
                var img = window.innerWidth > 750 ? imgPC : imgM
                $(item).css({
                    'background-image': 'url('+img+')'
                });
            });
        }).trigger('resize');
    }


    if ($('.js-slick-ib').length) {
        var slickIb = $('.js-slick-ib').slick({
            arrows: false,
            dots: true,
            dotsClass: 'comm-dots white text-center',
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false
        });
    }


    if ($('.js-slick-icase').length) {
        var slickIcase = $('.js-slick-icase').slick({
            arrows: true,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1101,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }

    if ($('.js-slick-pro').length) {
        var slickPro = $('.js-slick-pro').slick({
            arrows: true,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1101,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }

    if ($('.js-ipro-tab').length) {
        $('.js-ipro-tab span').on('click', function(){
            const index = $(this).index();
            $(this).addClass('current').siblings().removeClass('current');

            $('.iprob-item').removeClass('active').eq(index).addClass('active')
        });
    }

    if ($('.js-anim-num').length) {
        var isAniNum = false;
        
        $(window).on('scroll', function() {
            if ($(window).scrollTop() > $('.js-anim-num-box').offset().top - $(window).height() && $(window).scrollTop() < $('.js-anim-num-box').offset().top) {
                if (!isAniNum) {
                    isAniNum = true;
                    $('.js-anim-num').each(function(){
                        $(this).prop('Counter',0).animate({
                            Counter: $(this).text()
                        },{
                            duration: 2000,
                            easing: 'swing',
                            step: function (now){
                                $(this).text(Math.ceil(now));
                            }
                        });
                    });
                }
            }
        });
    }

    
})();


(function products(){

    if ($('.prod-table').length) {
        $('.prod-table').find('table').each(function(index, item) {
            const tr = $(item).find('tbody tr');
            // console.log(tr);
            let rspan = 0;
            let num = 0;
            tr.each(function(i, tritem) {
                console.log(i);
                const ftd = $(tritem).find('td').eq(0);

                const rowspan = ftd.attr('rowspan');

                // if ( rowspan && num < 1) {
                //     rspan = rowspan;
                //     num = rowspan
                // }
                if (num > 0) {
                    num--
                }
                if (num < 1) {
                    if (rowspan) {
                        num = rowspan
                    }
                    ftd.addClass('first')
                }
                console.log(num);

                 
            });
        })
    }

    if ($('.js-form-pjax').length) {
        // console.log('form pjax');
        // console.log($('form[data-pjax]'));
        

        // $(document).on('submit', 'form[data-pjax]', function(event) {
            
        // })
    }

    if ($('.fselect-item').length) {

        var pjax = new Pjax({
            elements: 'form[data-pjax]', // default is "a[href], form[action]"
            selectors: ['.pjax-products', '.js-filter-box'],
            scrollTo: false
        });

        console.log("Pjax initialized.", pjax);

        $(document).on('click', '.js-submit-filter', function(){
            $('.prod-filter-form').find('input').val('');
            // $('#productFilter').submit();
            const url = $(this).parents('form').attr('action');
            pjax.loadUrl(url);
        });


        $(document).on('click', '.fsi-header', function(e){
            e.stopPropagation();
            var item = $(this).parents('.fselect-item');
            var body = item.find('.fsi-body');

            // $('.fselect-item').each(function(i, t){
                
            //     if ($(t).html() !== item.html()) {
            //         $(t).removeClass('active');
            //         $(t).find('.fsi-body').removeClass('show');
            //         $(t).find('.fsi-body').slideUp(300);
            //         $(t).css({
            //             'z-index': 5
            //         });
            //     }
            // });

            if (item.hasClass('active')) {
                item.removeClass('active');
                body.removeClass('show');
                body.slideUp(300);
            } else {
                item.addClass('active');
                body.addClass('show');
                body.slideDown(300);
            }
        });
        $(document).on('click', '.fsi-option', function(e){
            e.stopPropagation();
            
            var item = $(this).parents('.fselect-item');
            var header = item.find('.fsi-header');
            var body = item.find('.fsi-body');
            var input = item.find('input[type=hidden]');
            var val = $(this).html();
            // header.html(val);
            body.removeClass('show');
            item.removeClass('active');
            if (input) {
                if ($(this).hasClass('current')) {
                    // return false;
                    input.val('');
                } else {
                    input.val($(this).attr('data-val'));
                }
                // $(this).parents('form').submit();
                const url = $(this).parents('form').attr('action')+'?'+$(this).parents('form').serialize();
                console.log(url);
                pjax.loadUrl(url);
            }
            setTimeout(function(){
                item.css({
                    'z-index': 5
                });
            }, 300)
        });
    }

    if ($('.js-slick-prod-img').length) {
        var slickProdimg = $('.js-slick-prod-img').slick({
            arrows: false,
            dots: true,
            dotsClass: 'comm-dots black text-center',
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false
        })
    }

    if ($('.js-slick-scenet').length) {
        var slickScene = $('.js-slick-scene').slick({
            arrows: false,
            dots: false,
            autoplay: false,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            asNavFor: '.js-slick-scenet',
            fade: true
        });
        var slickScenet = $('.js-slick-scenet').slick({
            arrows: false,
            dots: true,
            dotsClass: 'comm-dots white',
            autoplay: false,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            asNavFor: '.js-slick-scene'
        });
    }

    if ($('.js-slick-pb').length) {
        var slickPb = $('.js-slick-pb').slick({
            arrows: false,
            dots: true,
            dotsClass: 'comm-dots white bottom-60 text-center',
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false
        });
    }

    if (document.querySelector('.js-splide-prodimg')) {
        
        const splideProdimg = new Splide('.js-splide-prodimg', {

        }).mount();

        const splideProdimgs = new Splide('.js-splide-prodimg-small', {
            gap: 30,
            perMove: 1,
            perPage: 4,
            breakpoints: {
                1100: {
                    gap: 20
                }
            }
        }).mount();

        splideProdimg.sync(splideProdimgs);
    }

    

})();

(function support(){
    if ($('#downloadForm').length) {
        $('.js-layerd-close').on('click', function(){
            $('.layer-download').fadeOut();
        });

        $(document).on('click', '.js-pd-item', function(){

            const id = $(this).data('id');
            const filename = $(this).find('.pditem-title').html();
            $('#downloadId').val(id);
            // $('#downloadName').html(filename);
            $('.layer-download').fadeIn();
        });

        let isSubmit = true;
        const btnSubmit = $('.js-submit-download');
        const formObj = $('#downloadForm');
        formObj.validate({
            submitHandler: function(form) {
                if ( isSubmit ) {
                    isSubmit = false;
                    var postURL = $(form).attr('action');
                    var postData = new FormData(formObj[0]);
                    console.log(postData);
                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        url: postURL,
                        data: postData,
                        processData: false,
                        contentType: false,
                        error: function(){
                            layer.msg('我们遇到错误，请稍后再试！');
                            isSubmit = true;
                        },
                        success: function(res){
                            console.log(res);
                            if ( res.success) {
                                layer.msg('提交成功！');
                                formObj[0].reset();
                                isSubmit = true;


                                const filename = $('#downloadName').html();
                                // 创建隐藏的可下载链接
                                var eleLink = document.createElement('a');
                                // eleLink.download = filename;
                                eleLink.style.display = 'none';
                                // 字符内容转变成blob地址
                                // var blob = new Blob([res.url]);
                                eleLink.href = res.url;
                                // 触发点击
                                document.body.appendChild(eleLink);
                                eleLink.click();
                                // 然后移除
                                document.body.removeChild(eleLink);


                                $('.layer-download').fadeOut();
                            } else {
                                layer.msg(res.info_cn);
                            }
                        }
                    })
                }
            },
            rules: {
                phone: {
                    required: true,
                    isMobile: true
                },
                email: {
                    required: false,
                    email: true
                }
            },
            messages: {
                phone: {
                    required: '请输入手机号码'
                },
                email: {
                    required: '请输入邮箱地址',
                    email: '请输入有效的电子邮件地址'
                },
                
            }
        })
    }

    $('.js-video-item').on('click', function() {
        layerVideo.show($(this));
    });

    $(document).on('click', '.js-close-flyrlayer', function(){
        $(this).parents('.flyr-layer').remove();
    });

    if ($('.faq-item').length) {
        $('.faq-item').on('click', function(){
            const body = $(this).find('.faq-body');
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                body.slideUp(300);
            } else {
                $(this).addClass('active');
                body.slideDown(300);
            }
        });
    }
    if ($('.js-show-more').length) {
        $('.js-show-more').on('click', function(){
            $(this).parents('.show-more-box').toggleClass('show');
        });
    }
    
    // if ($('.js-scrollbar').length) {
    //     $('.js-scrollbar').niceScroll({
    //         cursorwidth: '2px',
    //         cursorcolor: '#ffffff',
    //         cursorborder: '0',
    //         autohidemode: false
    //     });
    // }

})();

(function about(){
    if ($('.js-slick-history').length) {
        var slickHistory = $('.js-slick-history').slick({
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 4000,
            infinite: false,
            asNavFor: '.js-slick-history-year'
        });

        var slickHistoryimg = $('.js-slick-history-img').slick({
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            draggable: false,
            infinite: true
        });

        var slickHistoryYear = $('.js-slick-history-year').slick({
            arrows: false,
            dots: false,
            slidesToShow: 8,
            slidesToScroll: 8,
            asNavFor: '.js-slick-history',
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        $('.history-event').on('mouseenter touchstart', function(){
            $(this).addClass('white').removeClass('white20').siblings().removeClass('white').addClass('white20');
        });
    }

    if ($('.js-slick-eva').length) {
        var slickEva = $('.js-slick-eva').slick({
            arrows: true,
            dots: true,
            dotsClass: 'comm-dots black text-center',
            autoplay: false,
            autoplaySpeed: 4000,
            pauseOnHover: false
        })
    }

    if ($('#contactForm').length) {
        // console.log('contactform')
        let isSubmit = true;
        const btnSubmit = $('.js-submit-contact');
        const formObj = $('#contactForm');
        formObj.validate({
            submitHandler: function(form) {
                if ( isSubmit ) {
                    isSubmit = false;
                    var postURL = $(form).attr('action');
                    var postData = new FormData(formObj[0]);
                    console.log(postData);
                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        url: postURL,
                        data: postData,
                        processData: false,
                        contentType: false,
                        error: function(){
                            layer.msg('We encountered an error, please try again later!');
                            isSubmit = true;
                        },
                        success: function(res){
                            console.log(res);
                            if ( res.success ) {
                                layer.msg('Submission successful!');
                                formObj[0].reset();
                                isSubmit = true;
                            } else {
                                layer.msg(res.info_cn);
                            }
                        }
                    })
                }
            },
            rules: {
                first_name: {
                    required: true
                },
                last_name: {
                    required: true
                },
                phone: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                },
                address: {
                    required: true
                },
                country: {
                    required: true
                },
                msg: {
                    required: true
                }
            }
        });
        
        btnSubmit.on('click', function(){

            const state = document.querySelector('.altcha').getAttribute('data-state');
            if (state == 'unverified') {
                layer.msg('Verification code verification failed, please verify again');
            } else {
                const v = document.querySelector('.altcha').querySelector('input[name=altcha]').value;
                console.log(v);

                $('#altcha_contact').val(v);

                formObj.submit();
            }
			
		});
    }
    if ($('.js-select2').length) {
        // console.log('ttt');
        $('.js-select2').each(function(index, item){
            const placeholder = $(item).attr('aria-placeholder');
            $(item).select2({
                placeholder: placeholder,
                minimumResultsForSearch: Infinity,
                dropdownParent: $('#select2Dropdown')
            });
        });


        $('.js-select2-inquire').on('change', function() {
            const val = $('.js-select2-inquire option:selected').val();
            if (val == 'Selling Agent') {
                $('.js-equipment-box').addClass('hidden');
            } else {
                $('.js-equipment-box').removeClass('hidden');
            }
        });
    }
    
})();

(function footer(){
    // Back to top button
    $('.js-gotop').on('click', function(){
        $('html,body').stop().animate({
                scrollTop : 0
        }, 'slow');
    });

    $(window).on('scroll', function(){
        $(window).scrollTop() > window.innerHeight*.3 ? $('.js-gotop').addClass('show') : $('.js-gotop').removeClass('show')
    });
    
    AOS.init({
        duration: 800,
        easing: 'ease-out',
        offset: 40
    });

    $(window).on('load', function(){
        var id = getQueryVariable('t');
        if (id != '') {
            scrollTo('#'+id);
        }
    });

})();

(function socialShre(){
    var share = new SimpleShare({
        url: '',
        title: '',
        content: '',
        pic: ''
    });
    $('[data-share]').on('click', function () {
        var type = $(this).attr('data-share');
        share.goShare(type);
    });
    $(document).on('click', '.js-wxClose', function(){
        $('.wx-share').remove();
    });
})()